// extracted by mini-css-extract-plugin
export default {"discount":"Lq","order_summary":"Mq","line_item":"Nq","separator":"Oq","order__summary_item_title":"Pq","recurringdis":"Qq","get_it_now_button":"Rq"};
    if(module.hot) {
      // 1715632474817
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  